<!--
 * @Author: 王丛
 * @Date: 2022-03-07 14:32:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-05-30 10:24:20
 * @Description: file content
-->
<template>
  <div class="psychological-counseling">
    <div
      class="banner"
      style="background-image:url(https://resource.chunyu.mobi/@/media/images/2022/03/10/6a45/52fb01caf211_w750_h622_.jpg)"
    >
      <div class="pc-cont">
        <div class="title">
          <span class="phone">接听手机</span>
          <div class="input-out">
            <input v-model="phone" type="text" placeholder="请输入手机号码" />
          </div>
        </div>
      </div>
    </div>
    <img
      class="pc-img"
      src="https://resource.chunyu.mobi/@/media/images/2022/05/30/4b3e/55656b080bfc_w750_h1158_.jpg"
    />
    <img
      class="pc-img"
      src="https://resource.chunyu.mobi/@/media/images/2022/03/10/c547/25035443202f_w750_h363_.jpg"
    />
    <img
      class="pc-img"
      src="https://resource.chunyu.mobi/@/media/images/2022/03/10/ef91/1710bc1f8365_w750_h671_.jpg"
    />
    <div class="footer-fix">
      <div class="footer-fix-cont">
        <p>
          合计：<span>￥</span><span>{{ price || '--' }}</span>
        </p>
        <div class="pc-btn" @click="handleSubmitConfirm">立即提交</div>
      </div>
    </div>
    <div class="footer-placeholder" />
    <Dialog
      :visible.sync="visible"
      :phone="phone"
      @handleSubmit="handleSubmit"
    />
  </div>
</template>

<script>
import * as cyDetect from '@cy/detect';
import cyShare from '@cy/share';
import { getClinicPrice, isLogin, createOrder } from '@/services';
import { isVersion91 } from '@/utils';
import { doPoint } from '@/utils/index';
import Dialog from '@/components/Dialog/index.vue';

console.log(isVersion91);

// const APP = cyDetect.isFromCYAll() ? '0' : 'weixin_mini';
const wx = require('weixin-js-sdk');

export default {
  name: 'PsychologicalCounseling',
  components: {
    Dialog,
  },
  data() {
    return {
      phone: '',
      isLogin: false,
      price: '',
      visible: false,
    };
  },
  watch: {},
  created() {
    this.getPhone();
    this.onShare();
    doPoint('PageView', {
      page_readable_name: '心理咨询热线',
    });
  },
  methods: {
    getPhone() {
      getClinicPrice().then(res => {
        const { clinic_info_list, phone, is_login } = res;
        console.log(clinic_info_list);
        const nb = clinic_info_list.filter(i => i.clinic_no === 'nb');
        this.price = nb.length > 0 ? nb[0]?.price : '';

        let PCPhone = window.localStorage.getItem(
          '__PsychologicalCounselingUserInfo__'
        );
        PCPhone = PCPhone && is_login ? JSON.parse(PCPhone).phone : '';
        console.log(PCPhone, phone);
        this.phone = PCPhone || phone;
        this.isLogin = is_login;
        console.log(nb.length);
      });
    },
    handleSubmitConfirm() {
      doPoint('AppClick', {
        click_position: '立即提交',
        page_readable_name: '心理咨询热线',
      });
      if (!this.phone) {
        this.$createToast({
          time: 1000,
          txt: '请填写手机号',
          type: 'txt',
        }).show();
        return;
      }
      if (!/^1[0-9]{10}$/.test(this.phone)) {
        this.$createToast({
          time: 1000,
          txt: '手机号格式不正确',
          type: 'txt',
        }).show();
        return;
      }
      window.localStorage.setItem(
        '__PsychologicalCounselingUserInfo__',
        JSON.stringify({ phone: this.phone })
      );
      this.visible = true;
    },
    handleSubmit() {
      doPoint('AppClick', {
        click_position: '确定',
        page_readable_name: '心理咨询热线',
      }).finally(() => {
        isLogin().then(res => {
          const { is_login } = res;
          this.isLogin = is_login;
          if (!is_login) {
            // 客户端环境下打开新 webview
            window.location.href = `${window.location.origin}/accounts/login/?next=${window.location.href}`;
          } else {
            // 创建订单所需参数，v1 支付
            const params = {
              finish_success_url: '',
              info_dict: JSON.stringify({
                phone: this.phone,
                clinic_no: 'nb',
              }),
              order_type: 'fast_phone',
              order_desc: '',
              order_name: `心理咨询热线服务`,
              partner: 'chunyu_wap_mini',
              clinic_name: '心理科',
              price: this.price,
            };
            // 跳转支付页面所需参数，v2 支付
            const v2Param = {
              finish_success_url: encodeURIComponent(
                '/ask/clinic/fast_phone_order/pay_success/page/?multi_clinic=True'
              ),
              order_type: 'fast_phone',
              order_desc: '',
              order_name: '心理咨询热线服务',
              partner: 'chunyu_wap',
            };
            const v2InfoDict = {
              phone: this.phone,
              clinic_no: 'nb',
            };
            // 春雨医生 app 中
            if (cyDetect.isFromCY()) {
              // 获取支付信息
              if (isVersion91) {
                return this.jumpV2Page(v2Param, v2InfoDict); // 跳转新支付页面
              }
              createOrder(params).then(r => {
                if (r.payment_order_id) {
                  // 成功之后，清除手机号，清除选择科室
                  localStorage.removeItem(
                    '__PsychologicalCounselingUserInfo__'
                  );
                  const url = `/weixin/pay/?pay_order_id=${res.payment_order_id}&common_pay=true`;
                  window.location.href = url;
                } else {
                  this.$createToast({
                    time: 1000,
                    txt: r.error_msg || '加载失败，请稍后重试',
                    type: 'txt',
                  }).show();
                }
              });
              return;
            }
            // 微信环境中
            if (cyDetect.isFromWechat()) {
              wx.miniProgram.getEnv(wxres => {
                if (wxres.miniprogram) {
                  wx.miniProgram.redirectTo({
                    url: `/pages/psychological_counseling_payment/index?price=${this.price}&phone=${this.phone}`,
                  });
                } else {
                  this.jumpV2Page(v2Param, v2InfoDict);
                }
              });
              return false;
            }
            // 普通 h5 中
            this.jumpV2Page(v2Param, v2InfoDict);
          }
        });
      });
    },

    jumpV2Page(params, infoObj) {
      const url = this.getPayV2Url(params, infoObj);
      console.log('v2跳转的链接', url);
      if (url) {
        window.location.href = url;
      } else {
        return false;
      }
    },
    getPayV2Url(params, infoObj) {
      if (!params || typeof params !== 'object') {
        return '';
      }

      const infoDict = encodeURIComponent(JSON.stringify(infoObj));

      const pay2Url = [
        '/weixin/pay/?',
        'pay_version=2',
        `&type=${params.order_type}`,
        `&order_type=${params.order_type}`,
        `&order_name=${params.order_name}`,
        `&order_desc=${params.order_desc || ''}`,
        `&partner=${params.partner || 'chunyu_wap'}`,
        `&return_url=${params.finish_success_url || ''}`,
        `&finish_success_url=${params.finish_success_url || ''}`,
        `&finish_fail_url=${params.finish_fail_url || ''}`,
        `&info=${infoDict}`,
      ].join('');

      return pay2Url;
    },
    /**
     * 分享设置
     *
     */
    onShare() {
      const params = {
        btn_visible: true, // 客户端右上角分享按钮的可见性,默认true
        do_share: false, // 不立即弹出分享菜单，默认false
        need_param: {
          version: true, // 是否携带app版本号
        },
        // 开启端上指定功能
        share_to: ['weixin_haoyou', 'weixin_pengyouquan', 'qq', 'weibo'],
        // 添加分享的图片
        img: '', // 分享的图片展示
        title: '心理咨询热线', // 标题
        desc: '春雨心理咨询师热线，将为您提供专业的心理与情绪疏导服务', // 描述
        link: window.location.href, // 分享后点击卡片的跳转链接
      };
      if (cyDetect.isFromWechat()) {
        cyShare.weixin({
          // img: '',
          title: '心理咨询热线', // 标题
          desc: '春雨心理咨询师热线，将为您提供专业的心理与情绪疏导服务', // 描述
          link: window.location.href,
        });
      } else {
        cyShare.app(params);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.psychological-counseling {
  margin-bottom: env(safe-area-inset-bottom);
  padding-bottom: rem(60);
  background: #fff;
}
.banner {
  position: relative;
  width: 100%;
  height: rem(311);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.pc-img {
  display: block;
  width: 100%;
}
@mixin btn-border($border, $radius) {
  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 200%;
    height: 200%;
    border: rem(1) solid $border;
    border-radius: rem($radius);
    transform: scale(0.5);
    transform-origin: 0 0;
    content: '';
  }
}
.pc-cont {
  @include btn-border(#fe7f36, 100);

  position: absolute;
  bottom: rem(25);
  left: 50%;
  width: rem(320);
  height: rem(37);
  text-align: left;
  background: #fff;
  transform: translateX(-50%);

  p {
    margin: 0;
  }

  .title {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    color: #323232;
    font-weight: 500;
    font-size: rem(16);
    line-height: rem(18);
    letter-spacing: 0;

    .input-out {
      flex: 1;
      height: rem(34);
      margin-left: rem(10);
      overflow: hidden;
      font-size: rem(14);
      border-radius: rem(4);
      input {
        width: 100%;
        height: rem(34);
        padding: 10px 0;
        padding-right: rem(20);
        color: #999;
        line-height: rem(14);
        background: transparent;
        border: none;
        outline: none;
        @include placeholder {
          color: #999;
        }
      }
    }
  }
  .phone {
    display: block;
    width: rem(88);
    height: rem(37);
    color: #fff;
    font-size: rem(14);
    line-height: rem(37);
    text-align: center;
    background: linear-gradient(90deg, #ff703e, #ff4317);
    border-radius: rem(50);
  }
}
.footer-fix {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  margin-bottom: env(safe-area-inset-bottom);
  background: #fff;
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.08);
  .footer-fix-cont {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: rem(375);
    height: rem(60);
    margin: auto;
    padding: rem(15);
    color: #666;
    > p span {
      margin-left: rem(-5);
      color: #ff6134;
      font-weight: 600;
      font-size: rem(16);
      font-family: 'PingFangSC-Regular', sans-serif;
      &:last-child {
        margin-left: rem(-2);
      }
    }
  }
  .pc-btn {
    width: rem(153);
    height: rem(44);
    color: #fff;
    font-weight: 500;
    font-size: rem(16);
    line-height: rem(44);
    text-align: center;
    background: #39d167;
    border-radius: rem(22);
  }
}
.footer-placeholder {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: env(safe-area-inset-bottom);
  background: #fff;
}
</style>
